var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"stickyButton"},[(_vm.error)?_c('b-flix-p',[_c('b-flix-alert',{staticClass:"mt-20",attrs:{"variant":"danger"}},[_vm._v(_vm._s(_vm.error))])],1):_c('saveButton',{on:{"save":function () { _vm.$emit('setSave', { exclude: _vm.newData.exclude }) }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }